import { render, staticRenderFns } from "./Unitplan.vue?vue&type=template&id=2b1b8c32&scoped=true&"
import script from "./Unitplan.vue?vue&type=script&lang=js&"
export * from "./Unitplan.vue?vue&type=script&lang=js&"
import style0 from "./Unitplan.vue?vue&type=style&index=0&id=2b1b8c32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1b8c32",
  null
  
)

export default component.exports